import moment from "moment";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const RequisitionRepPersonDate = () => {
  const [openElement, setOpenElement] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  const [typeError, setTypeError] = useState("");
  // get Enties All Product Data
  const {
    data: requisitionPersonDateWise,
    error,
    mutate,
  } = useSWR(
    selectedEmployee.value && toDate && fromDate
      ? `store/reports/requisitions?queryFor=person&fdate=${fromDate}&tdate=${toDate}&hrid=${selectedEmployee.value}`
      : null,
    fetcher
  );
  //console.log(requisitionPersonDateWise);
  // get Enployee data
  const { data: employeeOption, error: error1 } = useSWR(
    `hr/employee`,
    fetcher
  );
  // handle Employee select;
  const handleEmployee = (name) => {
    //console.log(name);
    setSelectedEmployee(name);
  };

  // set Employee category select list
  let employeeCategory = [];
  if (employeeOption && employeeOption.length > 0) {
    employeeCategory = employeeOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.EMPLOYE_ID;
      optionsItem.label = `${data.NAME_ENGLISH} ${data.DESIGNATION} ${data.DEPARTEMENT}`;
      return optionsItem;
    });
  }

  // toggle seach button
  const handleToggle = () => {
    if (!fromDate || !toDate || !selectedEmployee.value) {
      setTypeError("field Required");
      setOpenElement(false);
      setPrintButton(false);
    } else {
      setOpenElement(true);
      setPrintButton(true);
      setTypeError("");
    }
  };

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">{"label{font-size:1rem !important}"}</style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Requisition Reports By Person & Date Wise
            </h3>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-color px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              <div className="add_category text-center">
                <div className="row mx-3">
                  <div className="col-12 col-md-6 col-lg-6 mt-1">
                    <label htmlFor="Department">
                      Persons <span className="color-red">*</span>
                    </label>

                    <Select
                      onChange={handleEmployee}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={employeeCategory}
                    />
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0 }}
                      value={employeeCategory}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <label
                      htmlFor="text-start From_Date"
                      className="text-start"
                    >
                      From Date
                    </label>
                    <input
                      onChange={(e) => {
                        setFromDate(e.target.value);
                      }}
                      type="date"
                      name="From_Date"
                      className="p-2 input-field"
                    />
                    <p className="text-start text-danger">
                      {fromDate ? "" : typeError}
                    </p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <label htmlFor="To_Date">To Date</label>
                    <input
                      onChange={(e) => {
                        setToDate(e.target.value);
                      }}
                      type="date"
                      name="To_Date"
                      className="p-2 input-field"
                    />
                    <p className="text-start text-danger">
                      {toDate ? "" : typeError}
                    </p>
                  </div>
                </div>
                <br />
                <button
                  onClick={handleToggle}
                  type="button"
                  className="mt-3 px-5 btn btn-color_store"
                >
                  <i className="fa fa-search"></i>
                  <span> Search</span>
                </button>
              </div>

              {/* Search Result */}
              {requisitionPersonDateWise ? (
                <div
                  ref={componentRef}
                  className={
                    openElement
                      ? "category show my-4 table-container p-2"
                      : "category my-4 table-container p-2"
                  }
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>
                     
                      <h3>দ্রব্য চাহিদার পরিমাণ</h3>
                      <h5>
                        ( {selectedEmployee.label} <br /> From{" "}
                        {moment(new Date(fromDate)).format("DD-MM-YYYY")} To{" "}
                        {moment(new Date(toDate)).format("DD-MM-YYYY")} )
                      </h5>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr className="text-center">
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Date
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Product
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Requested
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Approved
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Remarks
                          </th>
                        </tr>
                      </thead>
                      {requisitionPersonDateWise.products && (
                        <tbody>
                          {requisitionPersonDateWise.products.map(
                            (product, index) => (
                              <tr key={index}>
                                <th className=" col-design1" colSpan="1">
                                  {index + 1}
                                </th>
                                <td
                                  style={{ whiteSpace: "nowrap" }}
                                  className=" col-design1"
                                  colSpan="1"
                                >
                                  {moment(new Date(product.PRODATE)).format(
                                    "DD-MM-YYYY"
                                  )}
                                </td>
                                <td
                                  className=" text-start col-design1"
                                  colSpan="1"
                                >
                                  {product.PRONAMETWO} <br /> ({product.PRONAME}
                                  )
                                </td>
                                <td
                                  colSpan="1"
                                  className="text-center col-design1"
                                >
                                  {product.PROREQUQTY}
                                </td>
                                <td
                                  colSpan="1"
                                  className="text-center col-design1"
                                >
                                  {product.APROQTY}
                                </td>
                                <td
                                  className="text-start col-design1"
                                  colSpan="1"
                                >
                                  {product.PREMARKS}
                                </td>
                              </tr>
                            )
                          )}

                          <tr>
                            <th className=" col-design1" colSpan="1"></th>
                            <td className=" col-design1" colSpan="1"></td>
                            <td colSpan="2" className="fw-bold col-design1">
                              Total Requisition
                            </td>
                            <td className="fw-bold col-design1" colSpan="1">
                              {requisitionPersonDateWise.TotalApprove}
                            </td>
                            <td className=" col-design1" colSpan="1"></td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default RequisitionRepPersonDate;
